import React from "react";
import {
  Dialog,
  DialogContent,
  TextField,
  Button,
  Typography,
  IconButton,
  Box,
  InputAdornment,
  useTheme,
} from "@mui/material";

import CloseIcon from "@mui/icons-material/Close";
import EmailIcon from "@mui/icons-material/Email";
import PhoneIphoneIcon from "@mui/icons-material/PhoneIphone";
import AssignmentIndIcon from "@mui/icons-material/AssignmentInd";

import useMediaQuery from "@mui/material/useMediaQuery";
import "../fade-animations.css";

const inputStyle = {
  background: "#ffffff",
  borderRadius: "12px",
  "& .MuiOutlinedInput-root": {
    borderRadius: "12px",
    boxShadow: "0 4px 14px rgba(0,0,0,0.05)",
    "& fieldset": { borderColor: "#e4e4e7" },
    "&:hover fieldset": { borderColor: "#b9b9c3" },
    "&.Mui-focused fieldset": { borderColor: "#5e17eb" },
  },
};

const CheckEligiblityv2 = ({ open, onClose }) => {

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  // ---------- ADDED FROM SCHOLAR REACT ----------
  const [gclid, setGclid] = React.useState("");

  const [formError, setFormError] = React.useState("");
  const [formValues, setFormValues] = React.useState({
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    website: window.location.href.slice(0, 250),
    description: window.location.href.includes("full-stack-web-development")
      ? "Full Stack Web Development"
      : window.location.href.includes("devops-and-cloud-training-online")
      ? "DevOps and Cloud with GenAI Master Program"
      : "DevOps and Cloud with GenAI Job Ready Program",
  });

  const [errors, setErrors] = React.useState({
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
  });

  const validateFirstName = (v) => (!v ? "First name is required" : "");
  const validateLastName = (v) => (!v ? "Last name is required" : "");
  const validateEmail = (v) => {
    if (!v) return "Email is required";
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return !emailRegex.test(v) ? "Invalid email address" : "";
  };
  const validatePhone = (v) => {
    if (!v) return "Phone number is required";
    const phoneRegex = /^\d{10}$/;
    return !phoneRegex.test(v) ? "Phone number must be 10 digits" : "";
  };

  const handleChange = (e, field) => {
    const { value } = e.target;

    setFormValues({ ...formValues, [field]: value });

    let error = "";
    switch (field) {
      case "firstName": error = validateFirstName(value); break;
      case "lastName": error = validateLastName(value); break;
      case "email": error = validateEmail(value); break;
      case "phone": error = validatePhone(value); break;
      default: break;
    }

    setErrors({ ...errors, [field]: error });
  };

  React.useEffect(() => {
    const urlGclid = new URLSearchParams(window.location.search).get("gclid");
    if (urlGclid) {
      localStorage.setItem("gclid", urlGclid);
      setGclid(urlGclid);
    } else {
      const storedGclid = localStorage.getItem("gclid");
      setGclid(storedGclid);
    }
  }, []);

  const handleFormSubmit = (event) => {
    event.preventDefault();

    const firstNameError = validateFirstName(formValues.firstName);
    const lastNameError = validateLastName(formValues.lastName);
    const emailError = validateEmail(formValues.email);
    const phoneError = validatePhone(formValues.phone);

    if (firstNameError || lastNameError || emailError || phoneError) {
      setErrors({
        firstName: firstNameError,
        lastName: lastNameError,
        email: emailError,
        phone: phoneError,
      });

      setFormError(
        firstNameError || lastNameError || emailError || phoneError
      );
      return;
    }

    document.forms["WebToLeads774394000000417076"].submit();
  };
  // ---------- END ADDED CODE ----------


  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth="md"
      PaperProps={{ sx: { borderRadius: "18px", overflow: "hidden" } }}
    >
      <IconButton
        aria-label="Close Eligibility Form"
        onClick={onClose}
        sx={{ position: "absolute", right: 14, top: 14, zIndex: 10 }}
      >
        <CloseIcon />
      </IconButton>

      <DialogContent sx={{ p: 0 }}>
        <Box display="flex" flexDirection={isMobile ? "column" : "row"}>

          {!isMobile && (
            <Box flex={1} sx={{ display:"flex", justifyContent:"center", alignItems:"center", background:"#ffffff" }}>
              <img loading="lazy" src={"https://img.freepik.com/free-photo/close-up-hands-holding-diplomas-caps_23-2148950575.jpg?t=st=1730547445~exp=1730551045~hmac=cfbb62de93f5c467b7cf3c4dee86e71dec373068d811f0248b28917b32611cb3&w=360"} alt="Consultation Offer" style={{ width:"100%", height:"100%", objectFit:"cover" }} />
            </Box>
          )}

          <Box flex={1} sx={{ p: { xs: 3, md: 4 } }}>
            <div className="fade-up-035">

              <Typography variant="h5" fontWeight={700} mb={1} sx={{ fontFamily: "Poppins, sans-serif" }}>Check Your Eligibility</Typography>
              <Typography color="text.secondary" mb={3} sx={{ fontFamily: "Poppins, sans-serif" }}>Get up to 35% off on our courses</Typography>

              {/* FORM WRAPPED HERE */}
              <form
                id="webform774394000000417076"
                action="https://crm.zoho.in/crm/WebToLeadForm"
                name="WebToLeads774394000000417076"
                method="POST"
                onSubmit={handleFormSubmit}
                acceptCharset="UTF-8"
              >

                {/* Hidden Zoho Fields */}
                <input type="hidden" name="xnQsjsdp" defaultValue="964543106c3ae7afbb5539a4799fc9369e01e4f472a15def1544213fb2881d33" />
                <input type="hidden" name="xmIwtLD" defaultValue="f51255974d13c7cf0e8e2bb0c5b883275629b31a45c7e2fffce67bae029b924214ce92ad42a0628f795719b65290f376" />
                <input type="hidden" name="actionType" defaultValue="TGVhZHM=" />
                <input type="hidden" name="returnURL" defaultValue="https://paperlive.in/thankyou" />
                <input type="hidden" id="zc_gad" name="zc_gad" value={gclid} />
                <input type="hidden" id="Website" name="Website" value={formValues.website} />
                <input type="hidden" id="Description" name="Description" value={formValues.description} />

                <Box sx={{ display:"grid", gap:"14px" }}>

                  <TextField
                    label="First Name"
                    id="First_Name"
                    name="First Name"
                    fullWidth
                    variant="outlined"
                    value={formValues.firstName}
                    onChange={(e)=>handleChange(e,"firstName")}
                    error={!!errors.firstName}
                    InputProps={{ startAdornment:(<InputAdornment position="start"><AssignmentIndIcon/></InputAdornment>) }}
                    sx={inputStyle}
                  />

                  <TextField
                    label="Last Name"
                    id="Last_Name"
                    name="Last Name"
                    fullWidth
                    variant="outlined"
                    value={formValues.lastName}
                    onChange={(e)=>handleChange(e,"lastName")}
                    error={!!errors.lastName}
                    InputProps={{ startAdornment:(<InputAdornment position="start"><AssignmentIndIcon/></InputAdornment>) }}
                    sx={inputStyle}
                  />

                  <TextField
                    label="Email"
                    id="Email"
                    name="Email"
                    type="email"
                    fullWidth
                    variant="outlined"
                    value={formValues.email}
                    onChange={(e)=>handleChange(e,"email")}
                    error={!!errors.email}
                    InputProps={{ startAdornment:(<InputAdornment position="start"><EmailIcon/></InputAdornment>) }}
                    sx={inputStyle}
                  />

                  <TextField
                    label="Phone Number"
                    id="Phone"
                    name="Phone"
                    type="tel"
                    fullWidth
                    variant="outlined"
                    value={formValues.phone}
                    onChange={(e)=>handleChange(e,"phone")}
                    error={!!errors.phone}
                    InputProps={{ startAdornment:(<InputAdornment position="start"><PhoneIphoneIcon/></InputAdornment>) }}
                    sx={inputStyle}
                  />

                  <div style={{ color:"red" }}>{formError}</div>

                  <Button
                    aria-label="Submit Eligibility Form"
                    variant="contained"
                    fullWidth
                    sx={{ mt:1, borderRadius:"12px", fontWeight:700, height:45, textTransform:"none", background:"#5e17eb", ":hover":{ background:"#4d13c6" }}}
                    type="submit"
                  >
                    Submit
                  </Button>

                </Box>

              </form>
            </div>
          </Box>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default CheckEligiblityv2;